module.exports = __webpack_public_path__ + "img/RealLogo.bb72908c.svg";